/*globals window, jQuery, MS, YT, analytics */
( function ( $ ) {
	'use strict';

	window.customAWA = {};

	if(  typeof analytics === 'undefined' ){
		return;
	}

	window.customAWA = ( function () {
		var player;
		var videoContainer;
		var isLoggedIn = $( 'body' ).hasClass( 'logged-in' );
		var slickClick = false;
		var videoData = {};

		/**
		 * Default values
		 * @type {{behavior: *, actionType: string, content: {contentName: string, slot: number, area: string}}}
		 */
		var overrideValues = {
			behavior  : 2,
			actionType: 'CL',
			content   : {contentName: '', slot: 1, area: ''}
		};

		/**
		 * Init AWA custom events
		 */
		var init = function () {
			//Track select dropdown on event forms
			$( '.msr-events-form' ).each( function () {
				var $self = $( this );
				var $selects = $self.find( 'select' );

				$selects.on( 'change', function ( e ) {
					var selected = $( this ).children( 'option:selected' );
					overrideValues.content = {
						contentName: sanitizeContentName( selected.text() ),
						slot       : 1,
						area       : 'table-filter-options'
					};
					analytics.capturePageAction( $self.get(0), overrideValues );
					awalog( $self, overrideValues );

				} );

			} );

			// Add event for Session form
			var $session_form = $( '#sessions-form' );

			$session_form.find('.custom-select-input').on( 'change',function (e) {
					var selected = $( this ).children( 'option:selected' );

					overrideValues.behavior = 4;
					overrideValues.content = {
						contentName: sanitizeContentName( selected.text() ),
						slot       : 1,
						area       : 'table-filter-options'
					};

					analytics.capturePageAction( $session_form.get(0), overrideValues );
					awalog( $session_form, overrideValues );

			} );

			// Add event for On Demand form
			var $on_demand_form = $( '#on-demand-form' );

			$on_demand_form.find('.custom-select-input').each(function(index){
					var $select = $(this);
					$select.on( 'change',function (e) {
						var selected = $( this ).find(':selected');

						overrideValues.behavior = 4;
						overrideValues.content = {
							contentName: sanitizeContentName( selected.text() ),
							slot       : 1,
							area       : 'table-filter-options'
						};

						analytics.capturePageAction( $on_demand_form.get(0), overrideValues );
						awalog( $on_demand_form, overrideValues );
					}
				)

			} );


			// Track search queries
			$( 'form[role="search"]' ).each( function () {
				var $this = $( this );
				var $form = $this.get(0);
				var $input = $form.querySelector('input[name="q"]');

				var overrideValues = {
					behavior: 61,
					actionType: 'CL',
					contentTags: {
						srchq: $input.value.toString(),
						name: 'Search',
						id: 'form-search'
					}
				};

				$form.onsubmit = function ( e ) {
					e.preventDefault();
					overrideValues.contentTags.srchq = $input.value.toString();
					analytics.capturePageAction( null, overrideValues );
					awalog( $input, overrideValues );
					$form.submit();
				};

			} );

			//AWA event for tabs
			$( '.msr-tab-list' ).on( 'click', '[role="tab"]', function ( e ) {
				e.preventDefault();
				var $this = $( this );
				var index = $this.parent().index();
				var label = $this.text();
				overrideValues.behavior = 2;
				overrideValues.content = {contentName: sanitizeContentName( label ), slot: index + 1 , area: 'tab'};
				/**
				 * #MSR-931 two things happening here:
				 * 1. We have dnt set on the tabs so they by default don't send any tracking data to AWA
				 * 2. We double trigger an event, a mouse click event and a sythentic jQuery event. To avoid double sending the analytics data, we ensure that the event is only run once.
				 */
				if ( e.originalEvent ) {
					$this.removeAttr( 'data-bi-dnt' );
					$this.data( 'bi-name', 'button' );
					analytics.capturePageAction( $this.get(0), overrideValues );
					$this.data( 'bi-name', 'button dnt' );
					$this.attr( 'data-bi-dnt', '' );
					awalog( '[role="tab"]', overrideValues );
				}
			} );

			//AWA events for video gallery clicks and video gallery details iframe
			$( '.video-gallery-trigger' ).on( 'click', function ( e ) {
				e.preventDefault();
				var $this = $( this );
				var label = $this.text();
				overrideValues.content = {contentName: sanitizeContentName( label ), slot: 1, area: 'video-gallery'};
				analytics.capturePageAction( $this.get(0), overrideValues );
				awalog( $this , overrideValues );
			} );

			//AWA events for show all
			$( document ).on( 'click', '.show-more',function ( e ) {
				e.preventDefault();
				var $this = $( this );
				var label = $this.text();

				overrideValues.content = {contentName: sanitizeContentName( label ), slot: 1, area: 'load-more'};
				analytics.capturePageAction( $this.get(0) , overrideValues );
				awalog( $this , overrideValues );
			} );

			//AWA event for video gallery detail drawer
			$( document ).on( 'click', '.msr-expandable-section a', function ( e ) {
				e.preventDefault();
				var $this = $( this );
				var label = $this.text();
				if ( $this.attr( 'aria-expanded' ) ===  'true' ) {
					//close
					overrideValues.behavior = 8;
				} else {
					//open
					overrideValues.behavior = 7;
				}
				overrideValues.content = {contentName: sanitizeContentName( label ), slot: 1, area: 'ajax-video-details'};
				analytics.capturePageAction( $this.get(0) , overrideValues );
				awalog( $this , overrideValues );

				//reset action type
				overrideValues.behavior = 2;
			} );

			//AWA for event widget pagination
			if( $( '.msr-table-pagination' ).length > 0 ){
				$( document ).on( 'click', '.page-numbers', function ( e ) {
					e.preventDefault();
					var $this = $( this );
					var label = $this.text();
					overrideValues.content = {contentName: sanitizeContentName( label ), slot: 1, area: 'table-filter-navigation'};
					analytics.capturePageAction( $this.get(0) , overrideValues );
					awalog( $this , overrideValues );
				} );
			}

			//AWA for carousels
			$( '.msr-hero-carousel, .msr-carousel, .msr-collections-carousel, .msr-section-front-carousel' ).on( 'afterChange', function ( event, slick, currentSlide ) {
				if ( slickClick ) {
					var area = $( event.currentTarget ).attr( 'data-bi-name' );
					var label = $( event.currentTarget ).find( 'article[data-slick-index="' + ( currentSlide + 1 ) + '"]' ).find( '.headline' ).text();
					overrideValues.content = {
						contentName: sanitizeContentName( label ),
						slot       : currentSlide + 1,
						area       : area
					};
					analytics.capturePageAction( $( this ).get(0), overrideValues );
					awalog( $( this ).get(0), overrideValues );
				}
				slickClick = false;
			} );

			//add dnt attributes to carousel navigation
			$( '.msr-hero-carousel, .msr-carousel, .msr-collections-carousel, .msr-section-front-carousel' ).on( 'init', function ( slick ) {
				window.setTimeout( function(){
					$( '.slide-arrow, .slide-dot' ).each( function( i ){
						$( this ).attr( 'data-bi-name', 'dnt button' ).attr( 'data-bi-dnt', '' );
					} );
					$( '.slide-arrow, .slide-dot' ).on( 'click', function( e ){
						e.preventDefault();
						slickClick = true;
					} );
				}, 500 );
			} );

			//AWA event for event table submit
			$( '.widget_filter_submit' ).on( 'click', function ( e ) {
				overrideValues.content = {contentName: 'submit', slot: 1, area: 'table-filter'};
				analytics.capturePageAction( $( '.msr-events-form' ).get(0) , overrideValues );
				awalog( $( '.msr-events-form' ), overrideValues );
			} );

			//AWA event for event table clear
			$( '.widget_filter_reset' ).on( 'click', function ( e ) {
				overrideValues.content = {contentName: 'reset', slot: 1, area: 'table-filter'};
				analytics.capturePageAction( $( '.msr-events-form' ).get(0), overrideValues );
				awalog( $( '.msr-events-form' ), overrideValues );
			} );
		};

		/**
		 * Log element and data being sent to AWA
		 *
		 * @param element
		 * @param values
		 */
		var awalog = function ( element, values ) {
			if ( isLoggedIn ) {
				console.log( element, values );
			}
		};

		/**
		 * Convert text to slug
		 *
		 * @param text
		 * @returns {string}
		 */
		var sanitizeContentName = function ( text ) {
			return text.toLowerCase().replace( /[^\w ]+/g, '' ).replace( / +/g, '-' );
		};

		//AWA register youtube videos.
		var registerYoutubeVideo = function () {
			videoContainer = $( document.getElementById( 'video-analytics' ) );
			if( typeof YT  !== 'undefined' && typeof YT.Player !== 'undefined' ){
				player = new YT.Player( 'video-analytics', {
					events: {
						'onStateChange': onYouTubePlayerStateChange
					}
				} );

				videoData = analytics.config.webAnalyticsConfiguration.coreData;
			} else {
				window.setTimeout( registerYoutubeVideo, 500 );
			}
		};

		/**
		 * Track youtube player interaction in AWA
		 *
		 * @param event
		 */
		var onYouTubePlayerStateChange = function ( event ) {
			var data = {};
			var videoContainer = document.getElementById( 'video-analytics' );
			switch ( event.data ) {
					case 0:
						data = {
							behavior   : 245,
							actionType : 'CL',
							contentTags: {
								vidnm: videoData.pageName
							}
						};
						analytics.capturePageAction( videoContainer, data );

						if ( isLoggedIn ) {
							console.log( data );
						}
						break;
					case 1:
						data = {
							behavior   : 240,
							actionType : 'CL',
							contentTags: {
								vidnm: videoData.pageName
							}
						};
						analytics.capturePageAction( videoContainer, data );

						if ( isLoggedIn ) {
							console.log( data );
						}
						break;
					case 2:
						data = {
							behavior   : 241,
							actionType : 'CL',
							contentTags: {
								vidnm: videoData.pageName
							}
						};
						analytics.capturePageAction( videoContainer, data );

						if ( isLoggedIn ) {
							console.log( data );
						}
						break;
			}


		};

		/**
		 * Track Azure Player interactions in AWA
		 *
		 * @param event
		 */
		var onAzureStateChange = function ( event ) {
			var SELF = $( document.getElementById( this.id_ ) );

			switch ( event.type ) {
					case 'ended':
						analytics.capturePageAction( {
							behavior   : 241,
							actionType : 'CL',
							contentTags: {
								vidnm: event.target.title
							}
						} );
						if ( isLoggedIn ) {
							console.log( event );
						}
						break;
					case 'play':
						analytics.capturePageAction( {
							behavior   : 240,
							actionType : 'CL',
							contentTags: {
								vidnm: event.target.title
							}
						} );
						if ( isLoggedIn ) {
							console.log( event );
						}
						break;
					case 'pause':
						analytics.capturePageAction( {
							behavior   : 241,
							actionType : 'CL',
							contentTags: {
								vidnm: event.target.title
							}
						} );
						if ( isLoggedIn ) {
							console.log( event );
						}
						break;
			}

		};

		return {
			init: init,
			registerYoutubeVideo: registerYoutubeVideo,
			onAzureStateChange  : onAzureStateChange
		};

	} )();

	window.customAWA.init();

} )( jQuery );
